import React from "react";
import {isRSAA, RSAA} from "redux-api-middleware/es";
import {push} from 'connected-react-router'

export const langApiWrapper = (store) => (next) => (action) => {
    if(!isRSAA(action)) {
        return next(action);
    }

    const {auth, ...rsaaAction} = action;
    const locale = store.getState().lang.locale;

    let modifiedHeaders = { ...rsaaAction[RSAA].headers, 'Accept-Language': locale };

    return (async() => {
        const response = await next({ ...action, [RSAA]: { ...rsaaAction[RSAA], headers: modifiedHeaders }});
        return response;
    })();
};

// export const apiUnauthorizedWrapper = ({dispatch}) => next => (action) => {
//     if(!isRSAA(action)) {
//         return next(action);
//     }
//
//     const {onFailure, ...rsaaAction} = action;
//     if(!onFailure) {
//         return (async() => {
//             const response = await next(rsaaAction);
//             if(response.error) {
//                 if (response.payload.status === 401) {
//                     dispatch(expired());
//                 }
//
//                 if (response.payload.status === 403) {
//                     dispatch(authInitAction('api/v1'));
//                     dispatch(push('/forbidden'));
//                 }
//             }
//             return response;
//         })();
//     }
//
//     return (async() => {
//         const response = await next(rsaaAction);
//         if(response.error && onFailure) {
//             dispatch(onFailure);
//         } else if(onSuccess) {
//             dispatch(onSuccess);
//         }
//         return response;
//     })();
// };
